// extracted by mini-css-extract-plugin
export default {"description":"updateFS_description__Epp3R","content":"updateFS_content__wgkjG"};